var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"convert-box",staticClass:"convert-box",class:{ 'convert-shadow': _vm.show },style:({ height: _vm.show ? '244px' : '0px', 'border-top': _vm.show ? '1px solid #E5E5E5' : '' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }